import React, { useEffect, useRef } from 'react';
import { CalendarIcon, MailIcon, LinkedinIcon, MapPinIcon, YoutubeIcon } from 'lucide-react';
import { NAVIGATE_EVENT } from '../../utils/router';
export function ContactContent() {
  const schedulerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let frame = 0;
    const scrollToScheduler = () => {
      if (window.location.hash !== '#book') return;
      frame = requestAnimationFrame(() => {
        schedulerRef.current?.scrollIntoView({
          block: 'start'
        });
      });
    };
    scrollToScheduler();
    window.addEventListener('hashchange', scrollToScheduler);
    window.addEventListener(NAVIGATE_EVENT, scrollToScheduler);
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('hashchange', scrollToScheduler);
      window.removeEventListener(NAVIGATE_EVENT, scrollToScheduler);
    };
  }, []);
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-7" data-mp="27v3h4f73rvy3">
      <div className="max-w-4xl mx-auto" data-id="element-8" data-mp="1ti83d48w063x">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-brand-navy mb-10 leading-tight" data-id="element-9" data-mp="1th6muk93qret">
          Let's talk.
        </h1>
        <p className="text-2xl md:text-3xl text-brand-gray leading-relaxed mb-12" data-id="element-10" data-mp="1yb12ncll6m8m">
          Whether you have a specific need or just want to explore how AI
          transformation could work for your team, I'd love to hear from you.
        </p>

        <div className="space-y-16" data-id="element-11" data-mp="2c8fwqumsbi6x">
          {/* Book a Call */}
          <div id="book" ref={schedulerRef} className="scroll-mt-28" data-id="element-12" data-mp="2h7sitd5u0l8g">
            <a href="https://scheduler.zoom.us/breakapencil/intro-call-30" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-10 py-5 border border-transparent text-xl font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-13" data-mp="2h70yiyhoq9xh">
              <CalendarIcon className="w-6 h-6" aria-hidden="true" data-id="element-14" data-mp="vsd58v751rcu" />
              Book a 30-minute intro call
              <span className="sr-only" data-id="element-15" data-mp="2ti1rujeudg3p">(opens in a new tab)</span>
            </a>
          </div>

          {/* Email */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-16" data-mp="2oqtg3gq1hind">
            <MailIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-17" data-mp="2js8gnjim32zz" />
            <div data-id="element-18" data-mp="2jq5pgw5q33to">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-19" data-mp="2fqn4y1htcurd">Email</h2>
              <a href="mailto:michael@breakapencil.com" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors border-b-2 border-brand-orange/30 hover:border-brand-orange pb-1" data-id="element-20" data-mp="2fokan59mofgu">
                michael@breakapencil.com
              </a>
            </div>
          </div>

          {/* Connect */}
          <div className="flex items-start py-8 border-b border-gray-100" data-id="element-21" data-mp="40kkhqbf9ei8">
            <LinkedinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-22" data-mp="3v75g7ncf9all" />
            <div data-id="element-23" data-mp="7jjn44obaird">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-24" data-mp="7hys6dy34xsz">
                Connect
              </h2>
              <div className="flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-25" data-mp="bj2bxbj97dzh">
                <a href="https://www.linkedin.com/in/mhirsch/" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-26" data-mp="gcd8mjucqedo">
                  <LinkedinIcon className="w-6 h-6 mr-3" data-id="element-27" data-mp="3orwwf3c974lc" />
                  LinkedIn
                </a>
                <a href="https://www.youtube.com/@Break-a-Pencil" target="_blank" rel="noopener noreferrer" className="text-xl text-brand-gray-light hover:text-brand-orange transition-colors inline-flex items-center" data-id="element-28" data-mp="3tpgjmsqxirpf">
                  <YoutubeIcon className="w-6 h-6 mr-3" data-id="element-29" data-mp="1dxj07jq2xa5o" />
                  YouTube
                </a>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="flex items-start py-8" data-id="element-30" data-mp="2hy97w2j978v1">
            <MapPinIcon className="w-8 h-8 text-brand-orange mr-6 mt-1 flex-shrink-0" data-id="element-31" data-mp="2vwpcnnxk2paj" />
            <div data-id="element-32" data-mp="2vucm4mdqf6lv">
              <h2 className="text-2xl font-bold text-brand-navy mb-4" data-id="element-33" data-mp="2qxvxzs6j8s8s">
                Location
              </h2>
              <p className="text-xl text-brand-gray-light" data-id="element-34" data-mp="35ud68ajfdqr4">
                Seattle, Washington. Working with teams everywhere.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}